import React from "react";
import { H4 } from "@irati/ui/src/Typography";
import { StyledHeader, StyledModal } from "./styled";
var HomepageModal = function (_a) {
    var children = _a.children, header = _a.header, onClose = _a.onClose;
    return (React.createElement(StyledModal, { onExited: onClose, onHide: onClose, renderHeader: function () { return (React.createElement(StyledHeader, null,
            React.createElement(H4, null, header))); }, show: true, useMobileStyling: false }, children));
};
export default HomepageModal;
